export default __webpack_public_path__ + "static/media/edit-icon.b76d899a.svg";